import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';

// Login popup: clients on tomorrow's calendar who have an outstanding balance.
// A friendly nudge to collect payment or update card info at the session.
// "Got it" snoozes for this login only — LoginPage clears the key on each
// login, so it reappears next time if the balance is still open.
export const DEBT_REMINDER_SNOOZE_KEY = 'debt_reminder_snooze';

const fmtMoney = (v) => `$${parseFloat(v || 0).toFixed(2)}`;

export default function DebtReminderPopup() {
  const [reminders, setReminders] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(DEBT_REMINDER_SNOOZE_KEY) === '1') return undefined;
    let active = true;
    API.get('/therapist/debt-reminders')
      .then((res) => {
        if (!active) return;
        if (Array.isArray(res.data) && res.data.length > 0) {
          setReminders(res.data);
          setOpen(true);
        }
      })
      .catch(() => { /* best-effort */ });
    return () => { active = false; };
  }, []);

  if (!open) return null;

  const dismiss = () => {
    sessionStorage.setItem(DEBT_REMINDER_SNOOZE_KEY, '1');
    setOpen(false);
  };
  const viewDebts = () => {
    sessionStorage.setItem(DEBT_REMINDER_SNOOZE_KEY, '1');
    navigate('/therapist/debt');
  };

  return (
    <div style={overlayStyle}>
      <div style={boxStyle}>
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <div style={{ fontSize: 32 }}>💛</div>
          <h2 style={{ margin: '4px 0 2px', fontSize: 20 }}>
            A friendly heads-up for tomorrow
          </h2>
          <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            {reminders.length === 1
              ? 'One of tomorrow’s clients has an outstanding balance.'
              : `${reminders.length} of tomorrow’s clients have outstanding balances.`}
          </div>
        </div>

        {reminders.map((r) => (
          <div key={r.clientId} style={rowStyle}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>
                {r.clientName}
                <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}> · {r.apptTime}</span>
              </div>
              <div style={{ fontSize: 13.5 }}>
                Outstanding balance: <strong>{fmtMoney(r.debtTotal)}</strong>
                {r.debtCount > 1 ? ` across ${r.debtCount} sessions` : ''}
              </div>
            </div>
          </div>
        ))}

        <div style={{ fontSize: 13.5, color: 'var(--text-strong)', margin: '10px 2px 0', lineHeight: 1.5 }}>
          When you see them tomorrow, it would be a big help to gently check in
          about the balance — collecting payment or updating their card on file
          both work. Thank you! 💚
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
          <button onClick={viewDebts} style={secondaryBtnStyle}>
            View debt sessions
          </button>
          <button onClick={dismiss} style={ctaStyle}>
            Got it — thanks!
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1090, padding: 16,
};
const boxStyle = {
  background: 'var(--white)', borderRadius: 16, padding: '20px 22px', width: '100%',
  maxWidth: 480, maxHeight: '88vh', overflowY: 'auto', boxShadow: '0 16px 48px rgba(0,0,0,0.35)',
};
const rowStyle = {
  display: 'flex', gap: 12, alignItems: 'center', padding: '9px 12px', margin: '6px 0',
  background: '#fff8e6', border: '1px solid #ffe69c', borderRadius: 10,
};
const ctaStyle = {
  flex: 1, background: 'var(--primary-color)', color: '#fff', border: 'none',
  borderRadius: 10, padding: '11px 14px', fontWeight: 700, fontSize: 14.5, cursor: 'pointer',
};
const secondaryBtnStyle = {
  flex: 1, background: 'var(--surface-muted)', color: 'var(--text-color)', border: 'none',
  borderRadius: 10, padding: '11px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer',
};
